import script from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__